import {
	PEOPLE_TRAINING_MODULE_TYPE,
	PEOPLE_TRAINING_PRACTICAL_OUTCOME,
} from '../../constants';

const MODULE_TYPE_ALIASES = {
	practical: PEOPLE_TRAINING_MODULE_TYPE.PRACTICAL,
	practicaltraining: PEOPLE_TRAINING_MODULE_TYPE.PRACTICAL,
	checklist: PEOPLE_TRAINING_MODULE_TYPE.PRACTICAL,
	checklisttraining: PEOPLE_TRAINING_MODULE_TYPE.PRACTICAL,
	slides: PEOPLE_TRAINING_MODULE_TYPE.SLIDES,
	slide: PEOPLE_TRAINING_MODULE_TYPE.SLIDES,
	richtext: PEOPLE_TRAINING_MODULE_TYPE.RICH_TEXT,
	rte: PEOPLE_TRAINING_MODULE_TYPE.RICH_TEXT,
	pdf: PEOPLE_TRAINING_MODULE_TYPE.PDF,
};

const PRACTICAL_OUTCOME_ALIASES = {
	competent: PEOPLE_TRAINING_PRACTICAL_OUTCOME.COMPETENT,
	pass: PEOPLE_TRAINING_PRACTICAL_OUTCOME.COMPETENT,
	passed: PEOPLE_TRAINING_PRACTICAL_OUTCOME.COMPETENT,
	complete: PEOPLE_TRAINING_PRACTICAL_OUTCOME.COMPETENT,
	completed: PEOPLE_TRAINING_PRACTICAL_OUTCOME.COMPETENT,
	needsfollowup: PEOPLE_TRAINING_PRACTICAL_OUTCOME.NEEDS_FOLLOW_UP,
	needsfollowuprequired: PEOPLE_TRAINING_PRACTICAL_OUTCOME.NEEDS_FOLLOW_UP,
	followup: PEOPLE_TRAINING_PRACTICAL_OUTCOME.NEEDS_FOLLOW_UP,
	failed: PEOPLE_TRAINING_PRACTICAL_OUTCOME.NEEDS_FOLLOW_UP,
	fail: PEOPLE_TRAINING_PRACTICAL_OUTCOME.NEEDS_FOLLOW_UP,
};

const normalizeKey = value => String(value || '')
	.trim()
	.toLowerCase()
	.replace(/[\s_-]+/g, '');

const toTrimmedString = (value, maxLength = 4000) => {
	if (value === undefined || value === null) {
		return '';
	}

	return String(value).trim().slice(0, maxLength);
};

export const normalizeTrainingModuleType = (value, fallback = PEOPLE_TRAINING_MODULE_TYPE.SLIDES) => {
	const alias = MODULE_TYPE_ALIASES[normalizeKey(value)];
	if (alias) {
		return alias;
	}

	return Object.values(PEOPLE_TRAINING_MODULE_TYPE).includes(value)
		? value
		: fallback;
};

export const inferTrainingModuleType = (trainingModule) => {
	const explicitType = normalizeTrainingModuleType(
		trainingModule?.trainingType || trainingModule?.contentType,
		'',
	);
	if (explicitType) {
		return explicitType;
	}

	if (Array.isArray(trainingModule?.practicalChecklistItems) && trainingModule.practicalChecklistItems.length) {
		return PEOPLE_TRAINING_MODULE_TYPE.PRACTICAL;
	}

	if (Array.isArray(trainingModule?.slides) && trainingModule.slides.length) {
		return PEOPLE_TRAINING_MODULE_TYPE.SLIDES;
	}

	if (trainingModule?.s3Key) {
		return PEOPLE_TRAINING_MODULE_TYPE.PDF;
	}

	if (String(trainingModule?.contentHtml || '').trim()) {
		return PEOPLE_TRAINING_MODULE_TYPE.RICH_TEXT;
	}

	return PEOPLE_TRAINING_MODULE_TYPE.SLIDES;
};

export const isPracticalTrainingModule = trainingModule => (
	inferTrainingModuleType(trainingModule) === PEOPLE_TRAINING_MODULE_TYPE.PRACTICAL
);

export const normalizePracticalChecklistItems = (items) => {
	const seenIds = new Set();
	const list = Array.isArray(items) ? items : [];

	return list
		.slice(0, 200)
		.reduce((acc, item, index) => {
			if (!item || typeof item !== 'object') {
				return acc;
			}

			const label = toTrimmedString(item.label || item.title || item.text, 500);
			const descriptionHtml = String(item.descriptionHtml || item.description || item.contentHtml || '').trim();
			if (!label && !descriptionHtml) {
				return acc;
			}

			let id = toTrimmedString(item.id, 120)
				.replace(/\s+/g, '_')
				.replace(/[^a-zA-Z0-9_-]/g, '');
			if (!id) {
				id = `checklist_${index + 1}`;
			}
			while (seenIds.has(id)) {
				id = `${id}_${index + 1}`;
			}
			seenIds.add(id);

			acc.push({
				id,
				label,
				descriptionHtml,
			});
			return acc;
		}, []);
};

export const normalizePracticalOutcome = (value, fallback = '') => {
	const alias = PRACTICAL_OUTCOME_ALIASES[normalizeKey(value)];
	if (alias) {
		return alias;
	}

	return Object.values(PEOPLE_TRAINING_PRACTICAL_OUTCOME).includes(value)
		? value
		: fallback;
};

export const isCompetentPracticalOutcome = value => (
	normalizePracticalOutcome(value) === PEOPLE_TRAINING_PRACTICAL_OUTCOME.COMPETENT
);
